<script setup lang="ts">
import schedule from "@/assets/schedule.json";
import { computed, ref } from "vue";

const showHistory = ref<boolean>(false);

const visibleSchedule = computed(() => {
  return schedule
    .filter(item => showHistory.value || new Date(item.date) >= new Date(new Date().toISOString().split('T')[0]))
    .filter(item => showHistory.value || !item.endTime || new Date(`${item.date}T${item.endTime}`) >= new Date());
});

</script>

<template>
<div class="page">
  <h2>Willkommen zum Pfingsturnier 2026!</h2>

  <div class="panel">
    <p class="text-center">
      Hier findest du die Ergebnisse der Spiele, sowie die Gruppeneinteilung.
    </p>
    <div class="link-area">
      <router-link :to="{ name: 'games' }" class="main-button">
        Spielplan
      </router-link>
      <router-link :to="{ name: 'groups' }" class="main-button">
        Gruppen
      </router-link>
    </div>
  </div>

  <div class="panel">
    <h3>
      Rahmenprogramm
    </h3>
    <p class="text-center">
      Hier findest du die Termine für das Rahmenprogramm des Pfingsturniers.
    </p>
    <button
      class="history-button"
      @click="showHistory = !showHistory"
      v-if="visibleSchedule.length != schedule.length"
    >
      {{ showHistory ? 'Vergangene Termine ausblenden' : 'Vergangene Termine anzeigen' }}
    </button>
    <template v-for="(scheduleItem, index) in visibleSchedule" :key="index">
      <div
        v-if="index === 0 || scheduleItem.date !== visibleSchedule[index - 1].date"
        class="text-center"
      >
        <h4>{{ new Date(scheduleItem.date).toLocaleDateString('de-DE', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        }) }}</h4>
      </div>
      <div class="schedule-item">
        <div>
          {{ scheduleItem.startTime }} {{ scheduleItem.endTime && `- ${scheduleItem.endTime}`}}
        </div>
        <div>
          {{ scheduleItem.title }}
        </div>
      </div>
    </template>
    <div class="text-center" v-if="visibleSchedule.length === 0">
      Danke das du dabei warst!<br>
      Wir wünschen eine gute Heimreise und freuen uns auf das nächste Pfingstturnier!
    </div>
  </div>
</div>
</template>

<style scoped>
.link-area {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

h2 {
  text-align: center;
}

h3 {
  color: var(--text-color-layer-0);
  font-weight: bold;
  text-align: center;
}

.text-center {
  text-align: center;
}

.main-button {
  display: inline-block;
  padding: 0.5rem 1rem;
  background-color: var(--main-color);
  color: var(--white);
  text-decoration: none;
  font-weight: bold;
  border-radius: 0.25rem;
  width: 10rem;
  text-align: center;
}

.schedule-item {
  display: grid;
  grid-template-columns: 7rem auto;
  color: var(--text-color-layer-0);
}

.history-button {
  margin: 0 auto;
  padding: 0.5rem 1rem;
  background-color: var(--color-layer-2);
  color: var(--text-color-layer-1 );
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
}
</style>
